import React from 'react';
import { Card } from './ui/card';
import { useContactForm } from '../hooks/useContactForm';
import { ContactForm } from './ContactForm';
import { ContactInfo } from './ContactInfo';

export const Contact = ({ t }) => {
  const { formData, isSubmitting, handleChange, handleSubmit } = useContactForm(t);

  return (
    <section id="contact" className="py-24 bg-gradient-to-b from-white to-slate-50 relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#D4AF37]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-500/5 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#001f3f] mb-6">
            {t.contact.title}
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed">
            {t.contact.subtitle}
          </p>
        </div>

        {/* Contact Form and Info Grid */}
        <div className="grid lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
          {/* Contact Form */}
          <Card className="p-8 border-slate-200 shadow-xl">
            <ContactForm 
              t={t}
              formData={formData}
              isSubmitting={isSubmitting}
              handleChange={handleChange}
              handleSubmit={handleSubmit}
            />
          </Card>

          {/* Contact Information */}
          <ContactInfo t={t} />
        </div>
      </div>
    </section>
  );
};
